const questionTypeValues = {
  Calculate: "calculate",
  Select: "select",
  FreeText: "free_text",
  Distribute: "distribute",
  Historical: "historical",
};

const QUESTION_TYPES = new Proxy(questionTypeValues, {
  get(target, prop) {
    if (prop === "toInt") {
      return (type) => {
        const typeMapping = {
          calculate: 1,
          select: 2,
          free_text: 3,
          distribute: 4,
          historical: 5,
        };
        if (typeMapping[type]) {
          return typeMapping[type];
        }
        throw new Error(`Unknown question type: ${type}`);
      };
    }

    if (prop === "toString") {
      return (type) => {
        const typeMapping = {
          calculate: "Calculate",
          select: "Select",
          free_text: "Free text",
          distribute: "Distribute",
          historical: "Historical",
        };
        if (typeMapping[type]) {
          return typeMapping[type];
        }
        throw new Error(`Unknown question type: ${type}`);
      };
    }
    return target[prop];
  },
});

export { QUESTION_TYPES };
